const enZA = {
  locale: 'en-ZA',
  productsAddedToBasket: {
    one: '[en-ZA] 1 product added to your basket',
    other: '[en-ZA] {count} products added to your basket'
  },
  basketItems: {
    one: '[en-ZA] 1 item in your basket',
    other: '[en-ZA] {count} items in your basket'
  },
  fakeStockItem: {
    one: '[en-ZA] 1 in stock on {date}',
    other: '[en-ZA] {count} in stock on {date}'
  },
  productStockInStock: {
    one: '[en-ZA] {count} in stock',
    other: '[en-ZA] {count} in stock'
  },
  productStockDueStock: {
    one: '[en-ZA] {count} Due: {date}',
    other: '[en-ZA] {count} Due: {date}'
  },
  searchProductDueStock: {
    one: '[en-ZA] Stock due {date}',
    other: '[en-ZA] Stock due on {date}'
  },
  filterViewResults: {
    one: '[en-ZA] View {count} Result',
    other: '[en-ZA] View {count} Results'
  },
  bulkBuyPack: {
    one: '[en-ZA] {count} pack',
    other: '[en-ZA] {count} pack'
  }
};

export default enZA;
